import React, { useContext } from 'react';
import { AuthContext, AuthContextProps } from 'shared/providers/auth';
import { buildNumber, displayVersion } from 'shared/utils/appVersionUtils';

import PageDownErrorMessage, {
  PageDownErrorMessageProps,
} from './PageDownErrorMessage';

export interface DefaultPageDownErrorMessageProps
  extends Omit<
    PageDownErrorMessageProps,
    | 'primaryButtonText'
    | 'primaryOnPress'
    | 'secondaryButtonText'
    | 'secondaryOnPress'
    | 'footerText'
  > {
  tryAgainAction: (...args) => unknown;
}

const DefaultPageDownErrorMessage = (
  props: DefaultPageDownErrorMessageProps,
) => {
  const { tryAgainAction } = props;
  const { handleLogout } = useContext<AuthContextProps>(AuthContext);

  return (
    <PageDownErrorMessage
      illustrationKey="HOURGLASS_A"
      {...props}
      primaryButtonText="Try again"
      primaryOnPress={tryAgainAction}
      secondaryButtonText="Log out"
      secondaryOnPress={handleLogout}
      footerText={`App version ${displayVersion} ${buildNumber ? `(${buildNumber})` : ''}`}
    />
  );
};

export default DefaultPageDownErrorMessage;
